'use client';

import canvasHelper from '../helper/canvas.js';
import data from '../helper/data.js';
import calculation from '../helper/calculation.js';
import '../../_virtual/_tslib.js';
import { defaultFont } from '../helper/config.js';
import Tooltip from './modules/tooltip.js';
import axes from './modules/axes.js';
import './modules/legend.rc.js';
import LineChart from './charts/line.js';
import LollipopChart from './charts/lollipop.js';

var Init = function (canvas, container, config) {
    var mouse;
    var reqId;
    var width, height;
    var chartInformation;
    var chartNecessaryInformation;
    var resizeObserver;
    var _a = config.chart, type = _a.type, autoResize = _a.autoResize;
    var _b = config.default || {}, defaultWidth = _b.width, defaultHeight = _b.height;
    function resetSize(cvWidth, cvHeight) {
        width = cvWidth;
        height = cvHeight;
    }
    function windowResetSize() {
        var width = defaultWidth || container.offsetWidth;
        var height = defaultHeight || container.offsetHeight;
        resetSize(width, height);
    }
    function animate(params) {
        var _a;
        var resizedCanvas = canvasHelper.createHiPPICanvas(canvas, width, height);
        var _b = ((_a = config.default) === null || _a === void 0 ? void 0 : _a.font) || {}, _c = _b.size, size = _c === void 0 ? defaultFont.size : _c, _d = _b.color, color = _d === void 0 ? defaultFont.color : _d, _e = _b.family, family = _e === void 0 ? defaultFont.family : _e, _f = _b.weight, weight = _f === void 0 ? defaultFont.weight : _f;
        var ctx = resizedCanvas.getContext('2d');
        if (ctx) {
            chartNecessaryInformation = calculation.getNecessaryInformation(ctx, chartInformation, width, height, config);
            ctx.clearRect(0, 0, width, height);
            /*
             * Set default font style
             * */
            ctx.fillStyle = color;
            ctx.font = "".concat(weight, " ").concat(size, "px ").concat(family);
            /*
             * End set default font style
             * */
            axes.setProps({
                ctx: ctx,
                chartInformation: chartInformation,
                chartNecessaryInformation: chartNecessaryInformation,
                config: config,
                mouse: mouse
            });
            var tooltipData = axes.draw();
            /*
             * Chart will go here
             * */
            switch (type) {
                case 'line':
                    {
                        LineChart({
                            ctx: ctx,
                            chartNecessaryInformation: chartNecessaryInformation,
                            chartInformation: chartInformation,
                            config: config,
                            mouse: mouse,
                            control: params.chart
                        }).draw();
                    }
                    break;
                case 'lollipop': {
                    LollipopChart({
                        ctx: ctx,
                        chartNecessaryInformation: chartNecessaryInformation,
                        chartInformation: chartInformation,
                        config: config,
                        control: params.chart
                    }).draw();
                }
            }
            /*
             * Tooltip is on top of all object, so that it alway been called at the end
             * of function
             * */
            Tooltip({
                config: config,
                chartArea: chartNecessaryInformation.chartArea,
                mouse: mouse,
                ctx: ctx,
                canvasSize: { width: width, height: height },
                tooltipData: tooltipData,
                control: params.tooltip
            }).draw();
        }
        reqId = requestAnimationFrame(animate.bind(null, params));
    }
    function handleMouseMove(e) {
        var canvas = e.target;
        var _a = canvas.getBoundingClientRect(), top = _a.top, left = _a.left;
        mouse = {
            x: e.clientX - left,
            y: e.clientY - top
        };
    }
    function handleMouseLeave() {
        mouse = null;
    }
    function run() {
        var getDefaultWidth = defaultWidth || container.offsetWidth;
        var getDefaultHeight = defaultHeight || container.offsetHeight;
        resetSize(getDefaultWidth, getDefaultHeight);
        chartInformation = data.getDataRangeInAxes(config.chart);
        animate({
            tooltip: {
                opacity: 0,
                yPos: 0,
                xPos: 0,
                dy: 0,
                dx: 0
            },
            chart: {
                controlRatio: 0
            }
        });
        canvas.addEventListener('mousemove', handleMouseMove);
        canvas.addEventListener('mouseleave', handleMouseLeave);
        if (autoResize) {
            resizeObserver = new ResizeObserver(function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    if (entry.borderBoxSize) {
                        var contentBoxSize = entry.contentBoxSize[0];
                        var getWidth = defaultWidth || contentBoxSize.inlineSize;
                        var getHeight = defaultHeight || contentBoxSize.blockSize;
                        resetSize(getWidth, getHeight);
                    }
                }
            });
            resizeObserver.observe(container);
        }
        else {
            window.addEventListener('resize', windowResetSize);
        }
    }
    function destroy() {
        if (autoResize && resizeObserver) {
            resizeObserver.disconnect();
        }
        else {
            window.removeEventListener('resize', windowResetSize);
        }
        canvas.removeEventListener('mousemove', handleMouseMove);
        canvas.removeEventListener('mouseleave', handleMouseLeave);
        cancelAnimationFrame(reqId);
    }
    return {
        run: run,
        destroy: destroy
    };
};

export { Init as default };
//# sourceMappingURL=init.js.map
